<template>
  <button class="share-copy__text share-copy__copy unstyled-btn" @click="copyLink">
    <img class="share-copy__link-icon" alt="An icon of a chain link." />
    <span v-text="shareCopy.copyLinkText" />
    <div :class="['copy-link__toast', addFadeOutClass ? 'fade-out' : '']" v-if="isToastVisible">Link copied</div>
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useTimeoutFn } from '@vueuse/core';
import { useContentStore } from '../../foundation/stores/contentStore';
import { storeToRefs } from 'pinia';
import { useAnalytics } from '../../composables/useAnalytics';
import { AnalyticsEventNames, AnalyticsEvents, AnalyticsEventTypes } from '../../foundation/enums/AnalyticsEvents';
/**
 * Data
 */

const isToastVisible = ref(false);
const addFadeOutClass = ref(false);
const contentStore = useContentStore();
const analytics = useAnalytics();
//Retrieve component content from content store
const { shareCopy } = storeToRefs(contentStore);

/**
 * Methods
 */

function pushToAnalytics(url: string) {
  try {
    analytics.push(AnalyticsEvents.NavigationClickToCopy, {
      eventInfo: {
        navigation: {
          name: AnalyticsEventNames.CopyLink,
          type: AnalyticsEventTypes.Share,
          URL: url,
        },
      },
    });
  } catch (error) {
    console.warn('Fail to push data to analytics', error);
  }
}

/**
 * Copy the url to the clipboard
 */
async function copyLink() {
  const url = window.location.href;
  pushToAnalytics(url);
  await navigator.clipboard.writeText(url).then(showToast);
}

/**
 * Add class to perform the fadeout animation and then hide the element at the end
 */
function showToast() {
  isToastVisible.value = true;
  addFadeOutClass.value = true;
  useTimeoutFn(hideToast, 3000);
}

function hideToast() {
  isToastVisible.value = false;
}
</script>

<style lang="scss" scoped>
.copy-link__toast {
  position: absolute;
  left: 100px;
  top: 0px;
  width: 186px;
  background-color: $racq-teal;
  color: $racq-true-white;
  border-radius: 4px;
  font-size: 1rem;
  text-align: center;
  line-height: 33px;
  cursor: default;
  background-image: url(@/assets/img/tick.svg);
  background-position: calc(50% - 55px);
  background-repeat: no-repeat;
  background-size: 1rem;
}

.share-copy__copy {
  display: flex;
  align-items: center;

  .share-copy__link-icon {
    width: 1rem;
    margin-right: 8px;
    content: url(@/assets/img/copy-link.svg);
  }

  &:hover {
    .share-copy__link-icon {
      content: url(@/assets/img/copy-link-blue.svg);
    }
  }
}
</style>
